import { createTheme } from '@material-ui/core/styles';
import BoschSans from '../fonts/BoschSans-Regular.woff2';

const boschSans = {
    fontFamily: 'Bosch Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    src: `
      url(${BoschSans}) format('woff2')
    `
  };

const theme = createTheme({
  palette: {
    primary: {main: '#007BC0'},
    secondary: {main: '#000000'},
    navbarBlue: {main: '#00629A'},
    warning: {light: "#ffdf95", main: "#cda600", dark: "#725b00"},
    error:{light: "#ffd9d9", main: "#D50005", dark: "#680001"},
    info: {light: "#d1e4ff", main: "#007BC0", dark: "#004975"}
  },
  typography: {
    fontFamily: 'Bosch Sans',
    fontWeightRegular: 400,
    fontWeightMedium: 300
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [boschSans],
        'fontWeight': 400,
      '.MuiButton-root': {
        },
      '.MuiButton-text':{
            "&:hover":{
              color: '#007BC0',
              backgroundColor: 'transparent',
            }
        },
      },
    },
    MuiButton:{
        root: {
            cursor: "pointer",
            textTransform: "none",
            borderRadius: 0,
            padding: ".75rem 1rem",
            "&:hover":{
              backgroundColor: "#00629a"
            },
            "&:active":{
              backgroundColor: "#004975"
            },      
        },
      outlined:{
            borderRadius: 0,
            padding: ".75rem 1rem",
      }
  },
  MuiListItem:{
    root:{
      padding: "0.75rem",
      "&:hover":{
        backgroundColor: "#e0e2e5"
      },
    }
  },
  MuiMenuItem:{
    root:{
      fontSize: "0.9rem",
      "&:hover":{
        backgroundColor: "#e0e2e5"
      }
    }
  }

}});

export {theme}